import React, { useEffect, useState } from 'react'
import '../spare/cu-spare.scss'
import NormalInput from '../../common/inputs/NormalInput'
import SelectInput from '../../common/inputs/SelectInput'

import { customerAxios } from '../../../config/axios'
import toast from 'react-hot-toast'



const CUProductVariant = ({ currentData, setModal, setData, isEdit }) => {
    const [form, setForm] = useState({})
    const [itemForm, setItemForm] = useState({})
    const [compForm, setCompForm] = useState({})
    const warrantyTypes = ['SERVICE PACKAGE', 'MONTH DURATION']
    const [loading, setLoading] = useState('fetch')
    const [components, setComponents] = useState([])
   
    const [parentProduct, setParentProduct] = useState({})
    const [productList, setProductList] = useState([])
   
    const [pid, setPId] = useState('')


    const toFixed2 = (value) => Number(value || 0).toFixed(2);

    const priceChangeInBundled = () => {
        let purchaseCost = Number(form.purchase_cost) || 0;
        let taxPercentage = Number(form.tax_percentage) || 0;

        let bcAmount = form.bundled_components?.reduce((acc, crr) => acc + Number(crr?.amount), 0) || 0;
        const gpAmount = Number(form.gp_amount) || 0;
        const taxBase = purchaseCost + gpAmount + bcAmount;

        // Tax Amount
        const taxAmount = taxBase * (taxPercentage / 100);

        // Selling Rate
        const sellingRate = taxBase + taxAmount;

        setForm({
            ...form,
            tax_amount: toFixed2(taxAmount),
            selling_rate: toFixed2(sellingRate)
        })
    }

    const handleChange = (e) => {

        let updatedForm = {
            ...form,
            [e.target.name]: e.target.value
        };

        let purchaseCost = Number(updatedForm.purchase_cost) || 0;
        let gpPercentage = Number(updatedForm.gp_percentage) || 0;
        let taxPercentage = Number(updatedForm.tax_percentage) || 0;
        let sellingRate = Number(updatedForm.selling_rate) || 0;

        let bcAmount = updatedForm.bundled_components?.reduce((acc, crr) => acc + Number(crr?.amount), 0) || 0;


        let gpAmount = 0;
        let taxAmount = 0;

        if (['purchase_cost', 'gp_percentage'].includes(e.target.name)) {

            gpAmount = (purchaseCost * gpPercentage) / 100;

            // Tax Amount
            const taxBase = purchaseCost + gpAmount + bcAmount;

            // Tax Amount
            taxAmount = taxBase * (taxPercentage / 100);

            // Selling Rate
            sellingRate = taxBase + taxAmount;

            updatedForm = {
                ...updatedForm,
                gp_amount: toFixed2(gpAmount),
                tax_amount: toFixed2(taxAmount),
                selling_rate: toFixed2(sellingRate)
            };

        } else if (e.target.name === "selling_rate") {
            // GP Amount from Selling Rate
            const beforeTax = sellingRate / (1 + taxPercentage / 100);

            gpAmount = beforeTax - purchaseCost - bcAmount;

            // Tax Amount
            taxAmount = beforeTax * (taxPercentage / 100);

            // GP Percentage
            gpPercentage = purchaseCost > 0 ? (gpAmount / purchaseCost) * 100 : 0;

            updatedForm = {
                ...updatedForm,
                gp_percentage: toFixed2(gpPercentage),
                gp_amount: toFixed2(gpAmount),
                tax_amount: toFixed2(taxAmount),
                selling_rate: toFixed2(sellingRate)
            };
        }

        setForm(updatedForm);
    }

    const handleChangeItemForm = (e) => {
        setItemForm({
            ...(itemForm || {}),
            [e.target.name]: e.target.value
        })
    }

    const handleChangeCompForm = (e) => {

        if (e.target.name === 'component_uuid') {
            const selected = components?.find((c) => c?.uuid === e.target.value)

            setCompForm({
                component_uuid: e.target.value,
                label: selected?.label,
                amount: selected?.default_rate || 0
            })

            return;
        }


        setCompForm({
            ...(compForm || {}),
            [e.target.name]: e.target.value
        })
    }

    const handleAddItem = () => {
        if (!itemForm?.spare_id || !itemForm?.qty) {
            return;
        }

        const existed = form?.item_list?.find(i => i?.spare_id === itemForm?.spare_id)
        if (existed) {
            toast.error('The item Id already exited')
            return
        }

        setForm({
            ...form,
            item_list: [
                ...(form?.item_list || []),
                itemForm
            ]
        })
    }

    const handleAddCompItem = () => {
        if (!compForm?.component_uuid || !compForm?.amount || !compForm?.required) {
            return;
        }

        const existed = form?.bundled_components?.find(i => i?.component_uuid === compForm?.component_uuid)
        if (existed) {
            toast.error('The Component already exited')
            return
        }

        setForm({
            ...form,
            bundled_components: [
                ...(form?.bundled_components || []),
                {
                    ...compForm,
                    required: compForm?.required === 'Yes' ? true : false
                }
            ]
        })

        setCompForm({})
    }

    const removeItem = (spare_id) => {
        setForm({
            ...form,
            item_list: (form?.item_list || [])?.filter(i => i?.spare_id !== spare_id)
        })
    }

    const removeCompItem = (uuid) => {
        setForm({
            ...form,
            bundled_components: (form?.bundled_components || [])?.filter(i => i?.component_uuid !== uuid)
        })
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        const body = {
            product_uuid: form?.product_uuid || null,
            description: form?.description || null,
            attributes: [],
            spares: form?.item_list || [],
            weight: form?.weight || 0,
            length: form?.length || 0,
            width: form?.width || 0,
            height: form?.height || 0,
            warranty_type: form?.warranty_type || null,
            warranty_package: form?.warranty_package || null,
            warranty_period: form?.warranty_period || null,
            rent_period: form?.rent_period || null,
            rent_charge: form?.rent_charge || null,
            bundled_components: form?.bundled_components || [],
            selling_rate: Number(form?.selling_rate) || 0,
            purchase_cost: Number(form?.purchase_cost) || 0,
            gp_percentage: Number(form?.gp_percentage) || 0
        }

        parentProduct?.attributes?.map((att) => {
            body.attributes.push({
                code: att?.code,
                value: form?.[att?.code] || null
            })
            return att
        })

        if (isEdit) {
            customerAxios.put(`/production-v0/product-variant/${currentData?.uuid}`, body).then(() => {
                setModal({ status: false })
                toast.success(`Product Updated! \n Refresh and Reopen the Product to View`)

            }).catch((error) => {
                toast.error(error.message)
            })
        } else {
            // Create new 
            customerAxios.post(`/production-v0/product-variant`, body).then(() => {
                setModal({ status: false })
                toast.success(`Product Created! \n Refresh and Reopen the Product to View`)

            }).catch((error) => {
                toast.error(error.message)
            })
        }
    }

    const handleFetchParentInfo = () => {
        if (pid) {
            setLoading('fetch')
            customerAxios.get(`/production-v0/parent-product/${pid}`)
                .then((res) => {
                    setParentProduct(res.data)

                    // Bundled
                    customerAxios.get(`/production-v0/bundled-components?for_use=${res.data?.product_category}&fields=uuid,label,default_rate,required`).then((res) => {
                        setComponents(res.data?.data || [])
                    }).catch((error) => {
                        toast.error(error.message)
                    })

                    // Update
                    let updateForm = {

                    }

                    if (isEdit) {
                        updateForm = {
                            product_uuid: currentData?.product_uuid,
                            description: currentData?.description,
                            weight: currentData?.weight,
                            length: currentData?.dimensions?.length,
                            width: currentData?.dimensions?.width,
                            height: currentData?.dimensions?.height,

                            warranty_type: currentData?.services?.has_iw_package ? 'SERVICE PACKAGE' : currentData?.services?.default_warranty?.period ? "MONTH DURATION" : '',
                            warranty_package: currentData?.services?.iw_package_id || '',
                            warranty_period: currentData?.services?.default_warranty?.period || '',

                            rent_period: currentData?.services?.rental_renewal?.rental_period || 0,
                            rent_charge: currentData?.services?.rental_renewal?.renewal_charge || 0,

                            item_list: currentData?.spares?.map(i => ({ spare_id: i?.spare_id, qty: i?.qty })),
                            bundled_components: currentData?.bundled_components?.map(i => ({ component_uuid: i?.component_uuid, label: i?.label, amount: i?.amount, required: i?.required })),

                            purchase_cost: currentData?.purchase_cost,
                            selling_rate: currentData?.selling_rate,
                            gp_percentage: currentData?.gross_profit?.percentage,
                            gp_amount: currentData?.gross_profit?.amount,
                            tax_percentage: currentData?.tax_percentage,
                            tax_amount: currentData?.tax_amount
                        }

                        currentData?.attributes?.map((att) => {
                            updateForm[att?.code] = att?.value
                            return att
                        })

                    } else {
                        updateForm = {
                            product_uuid: res.data?.uuid,
                            warranty_period: res.data?.warranty_period,
                            tax_percentage: res.data?.tax?.tax_percentage || 0
                        }
                    }

                    setForm(updateForm)
                    setLoading('')
                })
                .catch((error) => {
                    setLoading('')
                    toast.error(error.message)
                })
        }
    }

    const handleSelectProduct = (e) => {
        const productCode = e.target.value

        setPId(productCode)
    }



    useEffect(() => {
        priceChangeInBundled()
        // eslint-disable-next-line
    }, [form?.bundled_components])

    useEffect(() => {
        handleFetchParentInfo()
        // eslint-disable-next-line
    }, [pid])

    useEffect(() => {

        if (!isEdit) {
            setLoading('fetch')
            // call initial resources
            customerAxios.get(`/production-v0/parent-products?fields=uuid,product_name,product_code`).then((res) => {
                setProductList(res.data?.data || [])
                setLoading('')

            }).catch((error) => {
                setLoading('')
                toast.error(error.message)
            })
        } else {
            setPId(currentData?.product_code)
        }

        // eslint-disable-next-line
    }, [])


    if (loading === 'fetch') {
        return <p>Loading...</p>
    }

    // Page One
    if (!pid) {
        return <div className="cu-spare-sub-div">
            <form>
                <SelectInput label='Select Parent Product *' name='product_uuid'
                    values={productList?.map((u) => ({ option: `${u?.product_code} - ${u?.product_name}`, value: u?.product_code }))}
                    onChangeFun={handleSelectProduct} firstOption={{ option: 'Choose...', value: '' }} />
            </form>
        </div >
    }

    return (
        <div className="cu-spare-sub-div">

            {loading === 'fetch'
                ? <p>Loading....</p>
                : <form action="" onSubmit={handleSubmit}>
                    <div className="input-group-div">
                        <NormalInput label='Description *' name='description' value={form?.description} onChangeFun={handleChange} />
                        <NormalInput label='Weight *' name='weight' value={form?.weight} type={'number'} onChangeFun={handleChange} />
                        <NormalInput label='Length *' name='length' value={form?.length} type={'number'} onChangeFun={handleChange} />
                        <NormalInput label='Width *' name='width' value={form?.width} type={'number'} onChangeFun={handleChange} />
                        <NormalInput label='Height *' name='height' value={form?.height} type={'number'} onChangeFun={handleChange} />
                    </div>

                    <h4 style={{ fontSize: "14px", marginTop: "10px" }}>Attributes</h4>
                    <div className="input-group-div">
                        {parentProduct?.attributes?.map((att) => {
                            return <NormalInput label={att?.label} name={att?.code} value={form?.[att?.code]} onChangeFun={handleChange} />
                        })}
                    </div>

                    <h4 style={{ fontSize: "14px", marginTop: "10px" }}>Warranty {form?.product_category === 'ADD_ON' ? `& Rental` : ''}</h4>
                    <div className="input-group-div">
                        {parentProduct?.is_service_product && <>
                            <SelectInput label='Warranty Type *' name='warranty_type' values={warrantyTypes?.map((u) => ({ option: u, value: u, selected: u === form?.warranty_type }))} onChangeFun={handleChange}
                                firstOption={{ option: 'Choose...', value: '' }} />
                            {form?.warranty_type === 'SERVICE PACKAGE' &&
                                <NormalInput label='Warranty Package Id' name='warranty_package' value={form?.warranty_package} onChangeFun={handleChange} />}
                            {form?.warranty_type === 'MONTH DURATION' &&
                                <NormalInput label='Warranty Duration Months' type={'number'} name='warranty_period' value={form?.warranty_period} onChangeFun={handleChange} />}
                        </>}
                        {parentProduct?.is_rental_product && <>
                            <NormalInput label='Rent Period (Months)' name='rent_period' type={'number'} value={form?.rent_period} onChangeFun={handleChange} isRequired={false} />
                            <NormalInput label='Rent Charge' name='rent_charge' type={'number'} value={form?.rent_charge} onChangeFun={handleChange} isRequired={false} />
                        </>}
                    </div>

                    <h4 style={{ fontSize: "14px", marginTop: "10px" }}>Spares</h4>
                    <div className="item-list-div">
                        <table>
                            <tbody>
                                {form?.item_list?.map((item) => {
                                    return <tr>
                                        <td>{item?.spare_id}</td>
                                        <td>Qty : {item?.qty}</td>
                                        <td>
                                            <button type='button' onClick={() => removeItem(item?.spare_id)}>
                                                Delete
                                            </button>
                                        </td>
                                    </tr>
                                })}
                            </tbody>
                        </table>
                    </div>
                    <div className="add-item-div">
                        <NormalInput label='Spare Id' name='spare_id' value={itemForm?.spare_id} onChangeFun={handleChangeItemForm} isRequired={false} />
                        <NormalInput label='Qty' name='qty' value={itemForm?.qty} onChangeFun={handleChangeItemForm} isRequired={false} type={'number'} min={1} />
                        <button type='button' onClick={handleAddItem}>Add Item</button>
                    </div>

                    <h4 style={{ fontSize: "14px", marginTop: "10px" }}>Bundled Components</h4>
                    <div className="item-list-div">
                        <table>
                            <tbody>
                                {form?.bundled_components?.map((item) => {
                                    return <tr key={item?.component_uuid}>
                                        <td>{item?.label} {item?.required ? '(Required)' : ''}</td>
                                        <td>Amount : {item?.amount}</td>
                                        <td>
                                            <button type='button' onClick={() => removeCompItem(item?.component_uuid)}>
                                                Delete
                                            </button>
                                        </td>
                                    </tr>
                                })}
                            </tbody>
                        </table>
                    </div>
                    <div className="add-item-div" style={{ gridTemplateColumns: '1fr 1fr 1fr 100px' }}>
                        <SelectInput label='Bundled Component' name='component_uuid' values={(components || [])?.map((u) => ({ option: u?.label, value: u?.uuid, selected: u?.uuid === compForm?.component_uuid }))} onChangeFun={handleChangeCompForm}
                            firstOption={{ option: 'Choose...', value: '' }} isRequired={false} />
                        <NormalInput label='Amount' name='amount' value={compForm?.amount} onChangeFun={handleChangeCompForm} type={'number'} min={1} isRequired={false} />
                        <SelectInput label='Required' name='required' values={['Yes', 'No']?.map((u) => ({ option: u, value: u, selected: u === compForm?.required }))} onChangeFun={handleChangeCompForm}
                            firstOption={{ option: 'Choose...', value: '' }} isRequired={false} />
                        <button type='button' onClick={handleAddCompItem}>Add</button>
                    </div>

                    <h4 style={{ fontSize: "14px", marginTop: "10px" }}>Price Calculation</h4>
                    <p style={{ fontSize: "11px" }}>Selling Rate and Gross Profit are linked; a single change updates both.</p>
                    <div className="input-group-div">
                        <NormalInput label='Purchase Cost' name='purchase_cost' type={'number'} step="0.01" min={0} value={form?.purchase_cost} onChangeFun={handleChange} />  <br></br>
                        <NormalInput label='Gross Profit (Percentage)' name='gp_percentage' type={'number'} step="0.01" min={0} value={form?.gp_percentage} onChangeFun={handleChange} />
                        <NormalInput label='Gross Profit (Amount)' name='gp_amount' type={'number'} step="0.01" min={0} value={form?.gp_amount} style={{ backgroundColor: '#c9c9c9' }} />
                        <NormalInput label='Bundled Component Total' name='purchase_cost' type={'number'} step="0.01" min={0} value={form.bundled_components?.reduce((acc, crr) => acc + Number(crr?.amount), 0) || 0} style={{ backgroundColor: '#c9c9c9' }} />  <br></br>
                        <NormalInput label='Tax (Percentage)' name='tax_percentage' type={'number'} step="0.01" min={0} max={100} value={form?.tax_percentage} style={{ backgroundColor: '#c9c9c9' }} />
                        <NormalInput label='Tax (Amount)' name='tax_amount' type={'number'} step="0.01" min={0} value={form?.tax_amount} style={{ backgroundColor: '#c9c9c9' }} />
                        <NormalInput label='Selling Rate' name='selling_rate' type={'number'} step="0.01" min={0} value={form?.selling_rate} onChangeFun={handleChange} />
                    </div>

                    <button>Submit</button>
                </form>}
        </div>
    )
}

export default CUProductVariant